export enum AnalyticsEvent {
  SessionStart = "SessionStart",
  SessionEnd = "SessionEnd",
  ScreenView = "ScreenView"
}
